import {
    FETCH_CONSOLIDATED_FEEDBACK_FAILURE,
    FETCH_CONSOLIDATED_FEEDBACK_SUCCESS,
    POST_MANAGER_RATING_REQUEST,
    POST_MANAGER_RATING_SUCCESS,
    POST_MANAGER_RATING_FAILURE,
    PUT_MANAGER_RATING_REQUEST,
    PUT_MANAGER_RATING_SUCCESS,
    PUT_MANAGER_RATING_FAILURE,
    DELETE_MANAGER_RATING_SUCCESS,
    DELETE_MANAGER_RATING_FAILURE,
    FETCH_READ_COMMENT_SUCCESS,
    FETCH_READ_COMMENT_FAILURE,
    CLEAR_RATING_ERROR_NOTIFICATION
} from './constants';
import {
    FetchConsolidatedFBAction,
    PostManagerRatingAction,
    PutManagerRatingAction,
    DeleteManagerRatingAction
} from './typedef';

type IActions = FetchConsolidatedFBAction &
    PostManagerRatingAction &
    PutManagerRatingAction &
    DeleteManagerRatingAction;

const defaultState = {
    responseData: []
};

export const consolidatedFB = (state = defaultState, action: IActions) => {
    switch (action.type) {
        case FETCH_CONSOLIDATED_FEEDBACK_SUCCESS:
            return {
                ...state,
                responseData: action.data,
                pending: false
            };
        case FETCH_CONSOLIDATED_FEEDBACK_FAILURE:
            return {
                ...state,
                error: true,
                pending: false
            };
        case POST_MANAGER_RATING_REQUEST:
            return {
                ...state,
                pending: true
            };
        case POST_MANAGER_RATING_SUCCESS:
            return {
                ...state,
                responseData: action.data,
                pending: false
            };
        case POST_MANAGER_RATING_FAILURE:
            return {
                ...state,
                error: true,
                pending: false
            };
        case PUT_MANAGER_RATING_REQUEST:
            return {
                ...state,
                pending: true
            };
        case PUT_MANAGER_RATING_SUCCESS:
            return {
                ...state,
                responseData: action.data,
                pending: false,
                success: true
            };
        case PUT_MANAGER_RATING_FAILURE:
            return {
                ...state,
                error: true,
                pending: false
            };
        case DELETE_MANAGER_RATING_SUCCESS:
            return {
                ...state,
                responseData: action.data,
                pending: false
            };
        case DELETE_MANAGER_RATING_FAILURE:
            return {
                ...state,
                error: true,
                pending: false
            };
        case FETCH_READ_COMMENT_SUCCESS:
            return {
                ...state,
                responseData: action.data,
                pending: false
            };
        case FETCH_READ_COMMENT_FAILURE:
            return {
                ...state,
                error: true,
                pending: false
            };
        case CLEAR_RATING_ERROR_NOTIFICATION:
            return {
                ...state,
                error: false
            };
        default:
            return state;
    }
};
